import React from "react";

export default function LoginForm() {
  return (
    <form className="max-w-[520px] mx-auto w-full flex flex-col gap-5 sm::gap-[30px] px-5 xl:px-0">
      <h1 className="text-white text-[24px] xl:text-[32px] text-center font-bold">
        Login
      </h1>
      {/* id  */}
      <div className="grid grid-cols-[30px_1fr] sm:gap-[30px] gap-3 items-center">
        <label
          htmlFor="id"
          className="text-white text-[16px] xl:text-[20px]  font-bold"
        >
          ID
        </label>
        <div className="rounded-[10px] border border-[#BABABA] bg-white/10 backdrop-blur-[10px] sm:p-5 p-3 flex items-center gap-2.5">
          <UserIcon />
          <input
            type="email"
            name=""
            id="id"
            required
            placeholder="ID 를 입력해 주세요."
            className="flex-1 w-full border-none outline-none bg-transparent text-white placeholder:text-white text-[16px] xl:text-[20px] font-normal"
          />
        </div>
      </div>
      {/* submit btn  */}
      <div className="grid grid-cols-[30px_1fr] sm:gap-[30px] gap-3 items-center">
        <label
          htmlFor="pw"
          className="text-white text-[16px] xl:text-[20px]  font-bold"
        >
          PW
        </label>
        <div className="rounded-[10px] border border-[#BABABA] bg-white/10 backdrop-blur-[10px] sm:p-5 p-3 flex items-center gap-2.5">
          <LockIcon />
          <input
            type="password"
            name=""
            id="pw"
            required
            placeholder="비밀번호를 입력해 주세요."
            className="flex-1 w-full border-none outline-none bg-transparent text-white placeholder:text-white text-[16px] xl:text-[20px] font-normal"
          />
        </div>
      </div>
      {/* pw  */}
      <div className="grid grid-cols-[30px_1fr] sm:gap-[30px] gap-3 items-center">
        <span></span>
        <button className="bg-[#08F] border border-transparent hover:border-[#08F] hover:bg-white hover:text-[#08F] rounded-[10px] sm:p-5 p-3 text-white text-[16px] xl:text-[20px] font-normal hover:-translate-y-0.5 transition-all ease-linear duration-300">
          LOGIN
        </button>
      </div>
    </form>
  );
}

const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_0_25"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_0_25)">
        <path
          d="M12 11.6923C11.0375 11.6923 10.2136 11.3496 9.52825 10.6643C8.84275 9.97876 8.5 9.15476 8.5 8.19226C8.5 7.22976 8.84275 6.40584 9.52825 5.72051C10.2136 5.03501 11.0375 4.69226 12 4.69226C12.9625 4.69226 13.7864 5.03501 14.4718 5.72051C15.1573 6.40584 15.5 7.22976 15.5 8.19226C15.5 9.15476 15.1573 9.97876 14.4718 10.6643C13.7864 11.3496 12.9625 11.6923 12 11.6923ZM4.5 19.3078V17.0845C4.5 16.5948 4.633 16.1413 4.899 15.724C5.165 15.3067 5.5205 14.9858 5.9655 14.7615C6.95383 14.277 7.95092 13.9136 8.95675 13.6713C9.96258 13.4289 10.977 13.3078 12 13.3078C13.023 13.3078 14.0374 13.4289 15.0433 13.6713C16.0491 13.9136 17.0462 14.277 18.0345 14.7615C18.4795 14.9858 18.835 15.3067 19.101 15.724C19.367 16.1413 19.5 16.5948 19.5 17.0845V19.3078H4.5ZM6 17.8078H18V17.0845C18 16.882 17.9413 16.6945 17.824 16.522C17.7067 16.3497 17.5474 16.209 17.3462 16.1C16.4846 15.6757 15.6061 15.3542 14.7107 15.1355C13.8152 14.917 12.9117 14.8078 12 14.8078C11.0883 14.8078 10.1848 14.917 9.28925 15.1355C8.39392 15.3542 7.51542 15.6757 6.65375 16.1C6.45258 16.209 6.29333 16.3497 6.176 16.522C6.05867 16.6945 6 16.882 6 17.0845V17.8078ZM12 10.1923C12.55 10.1923 13.0208 9.99643 13.4125 9.60476C13.8042 9.21309 14 8.74226 14 8.19226C14 7.64226 13.8042 7.17143 13.4125 6.77976C13.0208 6.38809 12.55 6.19226 12 6.19226C11.45 6.19226 10.9792 6.38809 10.5875 6.77976C10.1958 7.17143 10 7.64226 10 8.19226C10 8.74226 10.1958 9.21309 10.5875 9.60476C10.9792 9.99643 11.45 10.1923 12 10.1923Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_0_31"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_0_31)">
        <path
          d="M6.30775 21.5C5.80908 21.5 5.38308 21.3234 5.02975 20.9703C4.67658 20.6169 4.5 20.1909 4.5 19.6923V10.3077C4.5 9.80908 4.67658 9.38308 5.02975 9.02975C5.38308 8.67658 5.80908 8.5 6.30775 8.5H7.5V6.5C7.5 5.25133 7.93783 4.18917 8.8135 3.3135C9.68917 2.43783 10.7513 2 12 2C13.2487 2 14.3108 2.43783 15.1865 3.3135C16.0622 4.18917 16.5 5.25133 16.5 6.5V8.5H17.6923C18.1909 8.5 18.6169 8.67658 18.9703 9.02975C19.3234 9.38308 19.5 9.80908 19.5 10.3077V19.6923C19.5 20.1909 19.3234 20.6169 18.9703 20.9703C18.6169 21.3234 18.1909 21.5 17.6923 21.5H6.30775ZM6.30775 20H17.6923C17.7821 20 17.8558 19.9712 17.9135 19.9135C17.9712 19.8558 18 19.7821 18 19.6923V10.3077C18 10.2179 17.9712 10.1442 17.9135 10.0865C17.8558 10.0288 17.7821 10 17.6923 10H6.30775C6.21792 10 6.14417 10.0288 6.0865 10.0865C6.02883 10.1442 6 10.2179 6 10.3077V19.6923C6 19.7821 6.02883 19.8558 6.0865 19.9135C6.14417 19.9712 6.21792 20 6.30775 20ZM12 16.75C12.4858 16.75 12.899 16.5798 13.2395 16.2395C13.5798 15.899 13.75 15.4858 13.75 15C13.75 14.5142 13.5798 14.101 13.2395 13.7605C12.899 13.4202 12.4858 13.25 12 13.25C11.5142 13.25 11.101 13.4202 10.7605 13.7605C10.4202 14.101 10.25 14.5142 10.25 15C10.25 15.4858 10.4202 15.899 10.7605 16.2395C11.101 16.5798 11.5142 16.75 12 16.75ZM9 8.5H15V6.5C15 5.66667 14.7083 4.95833 14.125 4.375C13.5417 3.79167 12.8333 3.5 12 3.5C11.1667 3.5 10.4583 3.79167 9.875 4.375C9.29167 4.95833 9 5.66667 9 6.5V8.5Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
